import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-progress-bar',
    template: ` <div
        class="cmps-progress-bar--bar"
        [style.background-color]="color"
        [style.width.%]="value * 100"
    ></div>`,
    host: {
        class: 'cmps-progress-bar',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsProgressBarComponent {
    @Input() color: string;
    @Input() value: number;
}
